import type { LicensedFeature } from "@octopusdeploy/octopus-server-client";
import type { ReactNode } from "react";
import { useIsLicensedFeatureEnabled } from "~/components/LicensedFeature/useIsLicensedFeatureEnabled";
export interface LicensedFeatureVisibilityProps {
    feature: LicensedFeature;
    disabledContent?: ReactNode;
    children?: ReactNode;
}
export default function LicensedFeatureVisibility({ feature, disabledContent, children }: LicensedFeatureVisibilityProps) {
    const isFeatureEnabled = useIsLicensedFeatureEnabled(feature);
    if (isFeatureEnabled) {
        return <>{children}</>;
    }
    return disabledContent ? <>{disabledContent}</> : null;
}
